import { Lock, Map } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useCookieConsent } from "@/hooks/useCookieConsent";

export function PrivacyConsentBanner() {
  const { t } = useTranslation();
  const { hasConsented, acceptAll, acceptEssentialOnly } = useCookieConsent();

  if (hasConsented) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card/95 backdrop-blur-md shadow-lg pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-2xl mx-auto px-3 py-2.5 flex items-center gap-3">
        <p className="text-xs text-muted-foreground leading-snug flex-1 min-w-0">
          {t(
            "privacy.consentShort",
            "We use cookies & local storage for app function and nearby map listings."
          )}{" "}
          <Link to="/privacy" className="text-primary underline underline-offset-2 hover:opacity-80">
            {t("privacy.viewPolicy", "Privacy Policy")}
          </Link>
        </p>
        <div className="flex gap-1.5 flex-shrink-0">
          <Button
            size="sm"
            variant="outline"
            className="h-8 px-2.5 text-xs"
            onClick={acceptEssentialOnly}
          >
            {t("privacy.essentialOnly", "Essential")}
          </Button>
          <Button
            size="sm"
            className="h-8 px-2.5 text-xs"
            onClick={acceptAll}
          >
            {t("privacy.acceptAll", "Accept All")}
          </Button>
        </div>
      </div>
    </div>
  );
}
